import AppointmentsPage from './AppointmentsPage'
export default AppointmentsPage